// noinspection JSNonASCIINames,NonAsciiCharacters

export const employeeTranslations = {
    new_employee: {
        header: "Уведомление о новом работнике",
        personal_info: {
            header: "Личные данные работника",
            lives_in_estonia: "Работник будет выполнять работу, проживая на территории Эстонии?",
            name: "Имя",
            surname: "Фамилия",
            full_name: "Полное имя работника",
            personal_code: "Личный код",
            residential_address: "Адрес места жительства работника",
            citizenship_question: "Работник имеет гражданство <1>Эстонии</1>, стран <3>ЕС/ЕЭЗ</3> или Щвейцарии?",
            citizenship_question_tip: "<0>Страны ЕС</0>Австрия, Бельгия, Болгария, Чехия, Дания, Франция, Французская Гвиана, Греция, Гваделупа, Хорватия, Эстония, Исландия, Италия, Ирландия, Кипр, Литва, Лихтенштейн, Люксембург, Мальта, Мартиника, Нидерланды, Норвегия, Польша, Португалия, Реюньон, Румыния, Словакия, Словения, Финляндия, Испания, Венгрия, Германия, Швеция." +
                "<br/><br/>" +
                "<3>Страны ЕЭЗ</3> Страны европейского союза + Исландия, Лихтенштейн, Норвегия",
            clear_data: "Удалить все ранее введенные данные",
            has_right_to_work: "Работник имеет право работать в Эстонии?",
            right_to_work_perm_permit: "Да, на основе постоянного ВНЖ",
            right_to_work_temp_permit: "Да, на основе временного ВНЖ",
            right_to_work_short_term_permit: "Да, на основе краткосрочного разрешения на работу",
            right_to_work_unknown: "Не знаю",
            ask_employee_status: "Если вы не знаете, имеет ли работник право работать в Эстонии - вы должны уточнить у него этот вопрос.",
            employee_should_know_status: "Работник обязан знать ответ на этот вопрос!",
            cant_hire: "Если иностранный работник не знает своего рабочего статуса - вы не можете принять его на работу.",
            allowed_to_work_based_on: "Может работать на основании",
            allowed_to_work_based_on_type: {
                citizenship: "Гражданства стран ЕС/ЕЭЗ",
                short_term: "Краткосрочного разрешения на работу",
                temp_permit: "Временного ВНЖ",
                perm_permit: "Постоянного ВНЖ",
                not_allowed: "Не имеет права работать в Эстонии!",
            },
        },
        contract_details: {
            header: "Данные договора",
            contract_type: "Тип договора",
            contract_employment: "Трудовой",
            contract_board: "Член правления",
            impossible_to_register: "Работник, проживающий вне Эстонии, не подлежит регистрации в Эстонском трудовом регистре",
            position: "Должность",
            work_address: "Адрес места работы",
            work_address_tip: "Укажите конкретный адрес, где будет находится работник для выполнения работы.<br/>" +
                "Если работник работает удалённо, то укажите его личный адрес.<br/>" +
                "Если работник водитель или моряк, укажите ваш юридический адрес.",
            rate_type: "Тип оплаты",
            hourly_rate: "Часовая",
            monthly_rate: "Месячная",
            salary: "Брутто-ставка зарплаты",
            salary_tip: "В соответствии с законом о трудовом договоре вы не можете указать в договоре нетто-сумму оплаты труда.<br/>" +
                "<2>Вам нужно указать брутто-сумму зарплаты</2><br/> " +
                "Вы можете использовать <5>зарплатный калькулятор</5> для расчета брутто-суммы договора<br/>" +
                "<2>Минимальная брутто-оплата труда в 2022 году - 654 евро в месяц или 3.86 евро в час.</2>",
            rate_per_month: "евро в месяц",
            rate_per_hour: "евро в час",
            works_full_time: "Работник работает с полной загрузкой?",
            time_allocation: "Ставка",
            full_time_allocation: "Полная занятость",
            part_time_allocation: "Частичная занятость",
            works_full_time_tip: "Если работник работает полный рабочий день - вам нужно выбрать<1>Да</1><br/>" +
                "В случае частичной занятости - цифра 1 означает, что работник работает полный рабочий день, а 0.5 - половину",
            start_date: "Дата начала договора *",
            has_end_date: "Договор имеет дату окончания действия?",
            end_date: "Дата окончания *",
            probation_period: "Договор имеет испытательный срок?",
            probation_period_len: "Испытательный срок (в месяцах)",
            probation_period_len_tip: "На основании закона о трудовом договоре испытательный срок не может быть более 4х месяцев",
        },
        tax_and_templates: {
            header: "Налогообложение",
            tax_residence: "Страна налогового резидентства",
            tax_residence_est: "Эстония",
            tax_residence_other: "Другая страна",
            tax_residence_country: "Страна",
            tax_residence_country_placeholder: "Страна налогового резидентства",
            tax_residence_unknown: "Неизвестно",
            ask_tax_residence: "Работник должен предоставить свидетельство о резидентстве из налогового департамента",
            tax_deduction: "Работнику нужен налоговый вычет?",
            tax_deduction_info_note: "Обратите внимание, что налоговый вычет не может быть использован, если месячный доход работника больше, чем 1200 евро брутто",
            tax_deduction_template: "Вы можете скачать шаблон заявления о налоговом вычете, нажав",
            should_we_register_employee: "Вы желаете, чтобы мы зарегистрировали нового работника в трудовом регистре?",
            should_we_register_employee_tip: "Если вы выберете <1>Да</1> - наш бухгалтер зарегистрирует нового работника в трудовом регистре.<br/>" +
                "Вам не нужно будет беспокоиться об этом.",
            need_contract_template: "Вам нужен шаблон договора?",
            countersigning_person_name: "Полное имя человека, подписывающего договор со стороны работодателя",
            countersigning_person_name_tip: "Обычно подпись ставит либо сам руководитель организации (генеральный директор), либо другой сотрудник по доверенности (начальник отдела кадров).",
            day_of_payment: "День выплаты (между 1 и 28 числом)",
            day_of_payment_tip: "К этой дате работадатель должен отправить платежное поручение в банк для перевода зарплаты работника",
            iban: "IBAN работника",
            duties_description: "Краткое описание обязанностей работника",
            check_before_signing: "После загрузки шаблона договора - проверьте его и подпишите",
            correctness_wavier: "Пожалуйста, обратите внимание, что мы не несем ответственность за правильность составления договора. Данный шаблон был создан на основании договоров с нашими работниками.",
            only_for_help_wavier: "Шаблон, который вы собираетесь скачать, был разработан как вспомогательное средство, все юридические риски вы берете на себя",
            download_here: "Вы можете скачать шаблон, нажав",
        },
        document_upload: {
            header: "Загрузка документов",
            document: "Документ работника (Паспорт или ИД-карта)",
            work_permit: "Документ, подтверждающий право на работу (карта резидента или Д-виза)",
            tax_residence: "Свидетельство о налоговом резидестве",
            tax_deduction: "Подписанное работником заявление о налоговом вычете",
            work_contract: "Подписанный трудовой договор",
        },
        review: {
            header: "Обзор",
            start_date: "Дата начала договора",
            end_date: "Дата окончания договора",
            perm_contract: "Отсутствует (бессрочный договор)",
            probation_period: "Испытательный срок",
            no_probation_period: "Без испытательного срока",
            probation_period_len_one: "{{count}} месяц",
            probation_period_len_other: "{{count}} месяца",
            should_we_register_worker: "Бухгалтер должен зарегистрировать работника в трудовом регистре?",
        },
        upload: {
            header: "Загрузка"
        },
    }
}